import * as i0 from "@angular/core";
var AnalyticService = /** @class */ (function () {
    function AnalyticService() {
        window['rawData'] = [];
    }
    AnalyticService.prototype.setAnalytics = function (contractData) {
        if (contractData) {
            window['rawData'] = contractData;
        }
    };
    AnalyticService.prototype.notifyAnalytics = function (eventNm) {
        if (eventNm === void 0) { eventNm = "ReqAppDataReady"; }
        // console.log('inside analytics method', typeof window['Bootstrapper']);
        window['analyticsDataReady'] = true;
        try {
            if (typeof window['Bootstrapper'] !== 'undefined') {
                window['Bootstrapper'].ensEvent.trigger(eventNm);
            }
        }
        catch (error) { }
    };
    AnalyticService.ngInjectableDef = i0.defineInjectable({ factory: function AnalyticService_Factory() { return new AnalyticService(); }, token: AnalyticService, providedIn: "root" });
    return AnalyticService;
}());
export { AnalyticService };
